import { apiRequest } from '../../api/http';

export const ADMIN_TASKS_CHANGED_EVENT = 'beaw:admin-tasks-changed';
let cachedCounts: Record<string, number> | null = null;
let cachedAt = 0;

export async function loadAdminTaskCounts(adminId: string, force = false): Promise<Record<string, number>> {
  if (!adminId) return {};
  if (!force && cachedCounts && Date.now() - cachedAt < 30_000) return cachedCounts;
  const result = await apiRequest<{ counts?: Record<string, number> }>('/admin/task-counts', { query: { admin_id: adminId } });
  cachedCounts = result.counts || {};
  cachedAt = Date.now();
  return cachedCounts;
}

export function notifyAdminTasksChanged() {
  window.dispatchEvent(new CustomEvent(ADMIN_TASKS_CHANGED_EVENT));
}
